<template>
    <div class="statsTitle">
        <div class="vs-item-blcok">{{ $t("dataStatistics.duiZhen") }}</div>
        <div class="each-stats-block">
            <a>{{ $t("dataStatistics.jinQiu") }}</a>
            <a>{{ $t("dataStatistics.dianQiu") }}</a>
            <a>{{ $t("dataStatistics.wuLong") }}</a>
            <a>{{ $t("dataStatistics.huangPai") }}</a>
            <a>{{ $t("dataStatistics.hongPai") }}</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'statsTitle'
}
</script>

<style lang="sass" scoped>
// 下方对阵得分列表的容器
.statsTitle
    display: flex
    padding-left: 15px
    padding-right: 15px
    height: 39px
    align-items: center
    color: #999999
    font-size: 12px

.statsTitle .vs-item-blcok
    width: 0
    padding-right: 15px
    flex-grow: 4
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.statsTitle .each-stats-block
    width: 0
    flex-grow: 6
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.each-stats-block
    display: flex
    justify-content: space-between
    text-align: center
    a
        width: 30px
</style>
